import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import ChainedBackend from 'i18next-chained-backend';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { LanguageOption } from '@monorepo/types';
import { EnvService } from './services/core/env-service';

const isS3BaseEnabled = EnvService.isS3BaseEnabled;
const localesPath = 'locales/{{lng}}/{{ns}}.json';
const s3LocalesPath = `${EnvService.s3BaseUrl}{{lng}}/{{ns}}.json`;

export const supportedLangs: string[] = [
  LanguageOption.ENGLISH,
  LanguageOption.HINDI,
  LanguageOption.JAPANESE,
  LanguageOption.PORTUGUESE,
  LanguageOption.SPANISH,
];

const PrimaryBackend = HttpBackend;
const FallbackBackend = HttpBackend;

const backend = {
  backends: [PrimaryBackend, FallbackBackend],
  backendOptions: isS3BaseEnabled
    ? [{ loadPath: s3LocalesPath }, { loadPath: localesPath }]
    : [{ loadPath: localesPath }, { loadPath: s3LocalesPath }],
};

i18n
  // .use(LanguageDetector)
  .use(ChainedBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: LanguageOption.ENGLISH,
    ns: [
      'common',
      'errors',
      'withdrawFunds',
      'mailConfirmation',
      'validations',
      'notificationCenter',
      'dashboardHeader',
      'keyMetrics',
      'accountStatistics',
      'activityLog',
      'performanceChart',
      'progressOverview',
      'admin',
      'notificationCenter',
      'hubCommon',
      'creditEventsModal',
      'novaContest',
      'purchase',
      'navigation',
      'affiliateProgram',
      'communityStats',
      'quick-purchase',
      'notification',
    ],
    supportedLngs: supportedLangs,
    backend,
    returnEmptyString: false,
  });
